import { MIME_TYPE, TEXT_CODEC } from '@24i/player-base';
import { Html5SupportedFormats } from '@24i/player-html5';

export class DashJsSupportedFormats extends Html5SupportedFormats {
    /**
     * Checks if manifest is supported by DASH.js engine
     * @param mimeType Manifest MIME type
     * @returns Manifest supported
     */
    checkManifest(mimeType: string): boolean {
        switch (mimeType) {
            case MIME_TYPE.DASH:
                return true;
            case MIME_TYPE.MPEG_DASH:
                return true;
            case MIME_TYPE.SMOOTH_STREAM:
                return true;
            default:
                return false;
        }
    }

    /**
     * Checks if native formats (MP4) are directly playable
     * @returns Should check direct MIME type support
     */
    checkNative(): boolean {
        return false;
    }

    /**
     * Check if named codec is supported by both engine and browser
     * @param codec Simple name of codec
     * @param mediaElement HTMLVideoElement instance
     * @returns Codec is supported by browser
     */
    checkCodec(codec: string, mediaElement: HTMLVideoElement): boolean {
        switch (codec) {
            case TEXT_CODEC.VTT:
                return true;
            default:
                return super.checkCodec(codec, mediaElement);
        }
    }
}